var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-6"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('Markdown',{staticClass:"privacy-text text-xs text-muted"},[_vm._v("\n    "+_vm._s(_vm.privacyText)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }